export default __webpack_public_path__ + "static/imxapps_as-639df775c462e59c9cf4a25f2e6848f2.png";